import { createAsyncThunk } from "@reduxjs/toolkit";
import { fetchBookingList } from "src/services/booking.service";



interface FetchBookingListPayload {
  page: number;
  limit: number;
}
export const doFetchBookingList = createAsyncThunk(
  "booking/fetchBookingList",
  async (payload: FetchBookingListPayload) => {
    try {
      const response = await fetchBookingList(payload);
      return response;
    } catch (error: any) {
      const errorMessage =
        error.response?.data?.message || "Failed to fetch booking list";
      throw errorMessage;
    }
  }
);